import { useState } from 'react'
import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'
import { ScoopText, ScoopColumn, ScoopRow, ScoopButton } from '../../../../../../ui'
import styles from './RecommendationsSection.module.scss'

export const RecommendationsSection = ({ recommendations }) => {
    const [recommendationsExpanded, setRecommendationsExpanded] = useState(true)

    if (!recommendations || recommendations.length === 0) return null

    // Get priority class
    const getPriorityClass = (priority) => {
        if (!priority) return styles.low
        const priorityUpper = priority.toUpperCase()
        if (priorityUpper === 'HIGH') return styles.high
        if (priorityUpper === 'MEDIUM') return styles.medium
        return styles.low
    }

    return (
        <ScoopColumn className={styles.container}>
            <ScoopRow className={styles.header}>
                <ScoopText className={styles.title}>
                    Recommendations ({recommendations.length})
                </ScoopText>
                <ScoopButton
                    variant="text"
                    size="xxs"
                    onClick={() => setRecommendationsExpanded(!recommendationsExpanded)}
                    className={styles.expandButton}
                    aria-label={
                        recommendationsExpanded
                            ? 'Collapse recommendations'
                            : 'Expand recommendations'
                    }
                >
                    {recommendationsExpanded ? (
                        <CaretUpIcon size={16} />
                    ) : (
                        <CaretDownIcon size={16} />
                    )}
                </ScoopButton>
            </ScoopRow>
            <div
                className={`${styles.collapseContainer} ${recommendationsExpanded ? styles.expanded : styles.collapsed}`}
            >
                {recommendations.map((rec, i) => (
                    <ScoopColumn
                        key={i}
                        className={`${styles.recommendationItem} ${getPriorityClass(rec.priority)}`}
                    >
                        <ScoopText className={styles.actionText}>
                            {rec.action || rec.recommendation}
                        </ScoopText>
                        {rec.rationale && (
                            <ScoopText className={styles.rationaleText}>{rec.rationale}</ScoopText>
                        )}
                        {rec.priority && (
                            <ScoopText className={styles.priorityText}>
                                Priority: {rec.priority}
                            </ScoopText>
                        )}
                    </ScoopColumn>
                ))}
            </div>
        </ScoopColumn>
    )
}
